var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C13.552 0 14 0.448 14 1V3H19C19.552 3 20 3.448 20 4V17C20 17.552 19.552 18 19 18H1C0.448 18 0 17.552 0 17V4C0 3.448 0.448 3 1 3H6V1C6 0.448 6.448 0 7 0H13ZM14 5H6V16H14V5ZM2 5V16H4V5H2ZM12 2H8V3H12V2ZM16 5V16H18V5H16Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKved);
export default __webpack_public_path__ + "static/media/kved.3ad34292c266fc4f404c7b71bf44763d.svg";
export { ForwardRef as ReactComponent };